/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import { UploadTabNames } from "./props";
import DocumentView from "./DocumentView";
import api from "../../../../api";
import { useDataLoader } from "react-remote-data-hooks";
import { ListHeaderDropdown, MediaFile, PaidBy, ProposalReason } from "../../../../core";
import { toastr } from "react-redux-toastr";
import SendClientApprovalForm from "./SendClientApprovalForm";
import moment from "moment";
import { LeadActivities } from "../activities/lead-activities";
import { ContainerLoader } from "../../../../components/loader";
import {
  Controller,
  useForm,
} from "../../../../../node_modules/react-hook-form/dist";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { AddNewLandLord } from "../../../AddLandLord/AddNewLandLord";
import AddNewUserModal from "../../../proposal/components/AddNewUser";
import InvoicePaymentForm, { PaymentFormProps } from "./InvoicePaymentForm";
import { DropdownList } from "react-widgets";
import AddUser from "../../../company/AddUser";
import { IDateRange } from "../../../../core/components/list-filters/DateRangeListFilter";
import { DocumentCopyType } from './List';

export interface MarkAsPaidFormProps {
  amount: number;
}

export enum InvoiceCopyType {
  Client = 'Client',
  LandLord = 'LandLord',
}

export interface InvoicePaymentHistory {
  createdAt?: Date;
  updatedAt?: Date;
  _id: string;
  addedBy?: any;
  invoiceId: string;
  amount: number;
  paidAt: Date;
  paidBy: string;
  status?: string;
  paymentMethod: any;
  bank?: string;
  comments?: string;
  reason?: string;
  invoiceCopyType: InvoiceCopyType;
  receipt?: MediaFile;
  refundMethod?: string;
  refundAmount?: string;
  refundTo?: string;
  isRefunded?: boolean;
  invoiceDetails: any;
}

const UploadDocument: React.FunctionComponent<{
  onClose?: () => void;
  reload?: () => void;
  documentId: string;
  proposalDocuments?: any[];
  leadId?: string;
  showAcceptButton?: boolean;
  showRejectButton?: boolean;
}> = (props) => {
  const [tabName, setTabName] = React.useState<UploadTabNames>();
  const setElementActive = (tabValue: UploadTabNames) => {
    setTabName(tabValue);
  };
  const [isSaving, setSaving] = React.useState(false);
  const [documentId, setDocumentId] = React.useState(props.documentId);

  const [openNewUserModal, setOpenNewUserModal] = React.useState<boolean>(
    false
  );
  const [isReload, setIsReload] = React.useState<boolean>(false);
  const [companyId, setCompanyId] = React.useState<string>("");
  const [dateFilters, setDateFilters] = useState<IDateRange>({
    startDate: moment(new Date()).startOf("year").toDate(),
    endDate: moment(new Date()).endOf("day").toDate(),
  });

  const { data: proposalDocument, reload, loading } = useDataLoader<any>(
    (docId: string) =>
      api.proposalDocument.findGenericProposalDocumentStageById(docId!),
    [documentId]
  );

  const [showRejectReasonModal, setShowRejectReasonModal] = React.useState<boolean>(
    false
  );

  const { data: reasons } = useDataLoader<ProposalReason[]>(() =>
    api.proposal.loadAllProposalReason({ entityType: "InvoiceReject" })
  );

  const { control, errors, handleSubmit } = useForm<any>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });


  React.useEffect(() => {
    if (!loading) {
      reload(documentId);
    }
  }, [documentId]);

  React.useEffect(() => {
    if (!tabName && proposalDocument?._id) {
      setTabName(
        !!proposalDocument?.seperateDocumentForLandlord
          ? UploadTabNames.InvoiceForLandlord
          : UploadTabNames.InvoiceForCustomer
      );
    }
  }, [proposalDocument?._id]);

  const isLandlordCopy = !!(tabName === UploadTabNames.InvoiceForLandlord);

  const document = isLandlordCopy
    ? proposalDocument?.seperateDocumentForLandlord
    : proposalDocument?.document;

    
  const { data: paymentHistory,reload: paymentHistoryReload, loading: paymentHistoryLoading } = useDataLoader<any>(
    (invoiceId: string) =>
      api.proposalDocument.getInvoicePaymentHistory({invoiceId, invoiceCopyType: tabName === UploadTabNames.InvoiceForCustomer ? PaidBy.Client : PaidBy.LandLord, fromDate: dateFilters.startDate, toDate: dateFilters.endDate, 
        // isRefunded :  false
      })
  );

  React.useEffect(() => {
    if (proposalDocument?._id &&  tabName) {
      paymentHistoryReload(proposalDocument?._id, tabName === UploadTabNames.InvoiceForCustomer ? PaidBy.Client : PaidBy.LandLord);
    }
  }, [proposalDocument?._id, tabName, dateFilters.endDate, dateFilters.startDate]);

  const [openApprovalModal, setOpenApprovalModal] = React.useState<{
    isOpen?: boolean;
    approvalType?: string;
    user?: string[];
  }>({});

  const [markAsPaidModalOpen, setMarkAsPaidModalOpen] = React.useState(false);

  const { control:rejectReasonControl, errors:rejectReasonErrors, handleSubmit:rejectReasonHandleSubmit } = useForm<any>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const onSend = async () => {
    setSaving(true);
    const createProposalData = {
      approvalType: "Internal",
      documentSettingsId: proposalDocument?.documentSettingsId,
      documentCopyType: isLandlordCopy ? "Landlord Copy" : "Client Copy",
    };

    await api.proposalDocument.requestApproval(
      createProposalData,
      proposalDocument?._id
    );
    setSaving(false);
    toastr.success(
      "Success", isLandlordCopy ? `The Landlord copy of invoice has been successfully submitted for internal approval.` :
      `The customer copy of invoice has been successfully submitted for internal approval.`
    );
    props.reload?.();
    reload(proposalDocument?._id);
  };
  const onApprove = async () => {
    setSaving(true);
    const createProposalData = {
      documentSettingsId: proposalDocument?.documentSettingsId,
      documentCopyType: isLandlordCopy ? "Landlord Copy" : "Client Copy",
    };

    await api.proposalDocument.internalApproval(
      createProposalData,
      proposalDocument?._id
    );
    setSaving(false);
    toastr.success(
      "Success", isLandlordCopy ? `The Landlord copy of invoice has been approved successfully.` :
      `The customer copy of invoice has been approved successfully`
    );

    props.reload?.();
    reload(proposalDocument?._id);
  };

  const onMarkAsPaid = async (data: PaymentFormProps) => {
    setSaving(true);

    const paidData = {
      amountPaid: Number(data.amountPaid),
      invoiceCopyType: isLandlordCopy ? PaidBy.LandLord : PaidBy.Client,
      paidBy: data.paidBy,
      paymentMethod: data.paymentMethod,
      bank: data.bank,
      receipt: data.receipt,
      date: data.date.toISOString(),
      comments: data.comments,
    };

   const response  =  await api.proposalDocument.markAsPaidTransaction(paidData, proposalDocument?._id);

   if(response?.status !== 200){
    toastr.error(
      "Error", response?.data?.message
     );
     setSaving(false);
   }else{

     setSaving(false);
     toastr.success(
       "Success", isLandlordCopy ? `The payment for the Landlord copy of invoice has been successfully recorded.` :
       `The payment for the customer copy of invoice has been successfully recorded.`
      );
      
      setMarkAsPaidModalOpen(false);
      props.reload?.();
      reload(proposalDocument?._id);
      paymentHistoryReload(proposalDocument?._id, tabName);
    }
  };

  const onReject = async (data: any) => {
    setSaving(true);
    const createProposalData = {
      reason: data.reason,
      comment: data.comment,
      approvalType: "Internal",
      documentSettingsId: proposalDocument?.documentSettingsId,
      documentCopyType: isLandlordCopy ? "Landlord Copy" : "Client Copy",
    };

    await api.proposalDocument.rejectApproval(
      createProposalData,
      proposalDocument?._id
    );
    setSaving(false);
    setShowRejectReasonModal(false);
    toastr.success(
      "Success", isLandlordCopy ? `The Landlord copy of invoice has been rejected successfully.` :
      `The customer copy of invoice has been rejected successfully.`
    );
    props.reload?.();
    reload(proposalDocument?._id);
  };
  const actions: any[] = [];

  const getStatus = () => {
    if (document?.internalApproval?.status === "Approved") {
      return "Internally Approved";
    }
    if (document?.internalApproval?.status === "Rejected") {
      return "Internally Rejected";
    }
    if (document?.internalApproval?.status === "Pending") {
      return "Internal Approval Pending";
    }
    return "Draft";
  };

  // const renderMarkAsPaid = () => {
  //   return markAsPaidModalOpen ? (
  //     <>
  //       <div
  //         className="modal fade show in"
  //         id="exampleModal"
  //         aria-labelledby="exampleModalLabel"
  //         aria-hidden="true"
  //         style={{ zIndex: 1053 }}
  //       >
  //         <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
  //           <div className="modal-content rounded-0">
  //             <div className="modal-body text-center">
  //               <form onSubmit={handleSubmit(onMarkAsPaid)}>
  //                 <div className="container">
  //                   <div className="row">
  //                     <div className="col">
  //                       <p>
  //                         Are you sure you want to mark this invoice as paid?
  //                       </p>
  //                     </div>
  //                   </div>
  //                   <div className="row">
  //                     <div className="col">
  //                       <div className="form-group font-weight-semibold mb-3 text-left">
  //                         <label htmlFor="" className="font-sm text-uppercase">
  //                           Amount<span className="text-danger">*</span>
  //                         </label>
  //                         <Controller
  //                           control={control}
  //                           name="amount"
  //                           rules={{ required: true }}
  //                           render={({ onChange, value, name }) => (
  //                             <input
  //                               type="number"
  //                               className="form-control rounded-sm font-weight-semibold"
  //                               placeholder="Enter amount"
  //                               name={name}
  //                               value={value}
  //                               onChange={(event: {
  //                                 target: { value: any };
  //                               }) => {
  //                                 let amount = event.target.value;
  //                                 amount = amount.replace(/[^0-9.]/g, "");
  //                                 const parts = amount.split(".");
  //                                 const integerPart = parts[0];
  //                                 const decimalPart = parts[1];
  //                                 if (decimalPart && decimalPart.length > 2) {
  //                                   amount = `${integerPart}.${decimalPart.slice(
  //                                     0,
  //                                     2
  //                                   )}`;
  //                                 }
  //                                 onChange(amount);
  //                               }}
  //                               id="amount"
  //                               min={1}
  //                               step="0.01"
  //                             />
  //                           )}
  //                         />
  //                         {errors.amount && (
  //                           <ErrorMessage>Amount is required</ErrorMessage>
  //                         )}
  //                       </div>
  //                     </div>
  //                   </div>
  //                   <div className="row">
  //                     <div className="col-auto mr-auto">
  //                       <button
  //                         className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-5 px-4 mr-3"
  //                         onClick={() => {
  //                           setMarkAsPaidModalOpen(false);
  //                         }}
  //                         disabled={isSaving}
  //                       >
  //                         Cancel
  //                       </button>
  //                     </div>
  //                     <div className="col-auto">
  //                       <button
  //                         className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
  //                         disabled={isSaving}
  //                       >
  //                         Submit
  //                       </button>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </form>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div
  //         className="modal-backdrop fade show"
  //         style={{ zIndex: 1052 }}
  //       ></div>
  //     </>
  //   ) : (
  //     <></>
  //   );
  // };

  const renderMarkAsPaid = () => {
    return markAsPaidModalOpen ? 
        <>
              <div
        className="detail-poupup detail-poupup--sm detail-poupup--mdx detail-poupup--over bg-gray-100 position-fixed top-0 w-100 h-100 overflow-auto in bg-white"
        style={{ zIndex: 1053 }}
      >
        <div className="container-fluid bg-gray-100 border-bottom py-3">
          <div className="row align-items-center">
            <div className="col-auto">
              <i
                className="icon-close font-xl cursor-pointer"
                onClick={() => {
                  // props.onClose?.();
                  setMarkAsPaidModalOpen(false);
                }}
              ></i>
            </div>
            <div className="co">
              <h2 className="mb-sm-0 font-base">
               Add Payment Transaction
              </h2>
            </div>
          </div>
        </div>
        <div className="container-fluid bg-white client-approval-form px-1">
          <div className="px-4 py-4">
                <InvoicePaymentForm tabName={tabName} proposalDocument={proposalDocument} onSubmit={onMarkAsPaid} setMarkAsPaidModalOpen={setMarkAsPaidModalOpen}  isSaving={isSaving}/>
          </div>
        </div >
      </div >
      <div
        className="modal-backdrop modal-backdrop--over fade show"
        style={{ zIndex: 1052 }}
      ></div>
        </>
     : <></>
  }

  const renderHeader = () => (
    <div className="container-fluid border-bottom py-3 proposal-head">
      <div className="d-flex align-items-center">
        <>
          <div
            className="col-auto px-0 cursor-pointer"
            onClick={() => {
              if (documentId !== props.documentId) {
                setDocumentId(props.documentId);
              } else {
                props.onClose?.();
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                d="M25.0416 0.292893C24.6511 -0.0976308 24.0179 -0.0976312 23.6274 0.292893L12.6673 11.253L1.70711 0.292893C1.31658 -0.0976312 0.683417 -0.0976308 0.292893 0.292893C-0.0976308 0.683417 -0.0976312 1.31658 0.292893 1.70711L11.253 12.6673L0.292893 23.6274C-0.0976308 24.0179 -0.0976308 24.6511 0.292893 25.0416C0.683417 25.4322 1.31658 25.4322 1.70711 25.0416L12.6673 14.0815L23.6274 25.0416C24.0179 25.4322 24.6511 25.4322 25.0416 25.0416C25.4322 24.6511 25.4322 24.0179 25.0416 23.6274L14.0815 12.6673L25.0416 1.70711C25.4322 1.31658 25.4322 0.683417 25.0416 0.292893Z"
                fill="#6F7171"
              />
            </svg>
          </div>
          <div className="col">
            {proposalDocument?.proposedPropertyDetails.map((element: any,  index: number) => (
              <>
                <div className=" d-flex align-items-center">
                  <label className="font-md font-weight-semibold mb-0 ">
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.projectName
                    }{" "}
                    / Floor :{" "}
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.floor
                    }{" "}
                    / Unit :{" "}
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.unitName
                    }{" "}
                    / Area :{" "}
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.area
                    }
                  </label>
                  {!!(proposalDocument.proposedPropertyDetails.length === index + 1) && <>
                  {!document?.clientApproval && !document?.landlordApproval ? (
                    <span
                      className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                    >
                      {getStatus()}
                    </span>
                  ) : (
                    <>
                      {document?.paymentDetails?.paymentStatus === "Paid" || document?.paymentDetails?.paymentStatus === "PaymentCollection" ? (
                        <span
                          className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                        >
                          {document?.paymentDetails?.paymentStatus === "PaymentCollection" ?
                          "Payment in Progress" : "Payment Collected"}
                        </span>
                      ) :
                      <>
                       {!!document?.clientApproval &&
                        document?.paymentDetails?.paymentStatus !== "Paid" && (
                          <span
                            className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                          >
                            {document?.clientApproval.status === "Pending"
                              ? "Sent to Client"
                              : "Client Approved"}
                          </span>
                        )}
                       {!!document?.landlordApproval &&
                        document?.paymentDetails?.paymentStatus !== "Paid" && (
                          <span
                            className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                          >
                            {document?.landlordApproval.status === "Pending"
                              ? "Sent to Owner"
                              : "Vendor/Owner Approved"}
                          </span>
                        )}
                      </>
                      }
                    </>
                  )}
                   </>}
                </div>
                {!!(proposalDocument.proposedPropertyDetails.length === index + 1) &&<span className="d-block  font-xs text-gray-500 font-weight-semibold">
                  Created By{" "}
                  <span className="text-dark">
                    {proposalDocument?.createdBy?.name}
                  </span>{" "}
                  on{" "}
                  <span className="text-dark">
                    {moment(tabName === UploadTabNames.InvoiceForCustomer ?  proposalDocument?.document?.createdAt : proposalDocument?.seperateDocumentForLandlord?.createdAt).format(
                      "DD MMM YYYY hh:mm A"
                    )}
                  </span>
                </span>}
              </>
            ))}
          </div>

          <div className="col-auto mt-md-0 mt-1 ml-auto">
            {document?.status === "Draft" && !document?.internalApproval && (
              <button
                type="button"
                onClick={onSend}
                className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                disabled={isSaving}
              >
                Send For Internal Approval
              </button>
            )}
            {document?.internalApproval?.status === "Pending" && (
              <>
                {props.showRejectButton && <button
                  type="button"
                  onClick={()=>{setShowRejectReasonModal(true)}}
                  className="btn btn-outline-primary bg-white text-primary px-4 font-normal font-weight-bold py-2 rounded mx-2 "
                  disabled={isSaving}
                >
                  Reject
                </button>}
                {props.showAcceptButton && <button
                  type="button"
                  onClick={onApprove}
                  className="btn btn-primary px-4  font-normal font-weight-bold py-2 rounded"
                  disabled={isSaving}
                >
                  Approve
                </button>}
              </>
            )}
            {document?.internalApproval?.status === "Approved" &&
              isLandlordCopy &&
              !document?.landlordApproval &&
              document?.paymentDetails?.paymentStatus !== "Paid" && (
                <button
                  type="button"
                  onClick={() => {
                    setOpenApprovalModal({
                      isOpen: true,
                      approvalType: "Landlord",
                    });
                  }}
                  className="btn btn-outline-primary px-4 mr-3 font-normal font-weight-bold py-2 rounded"
                  disabled={isSaving}
                >
                  Send to Vendor / Owner
                </button>
              )}
            {document?.internalApproval?.status === "Approved" &&
              document?.paymentDetails?.paymentStatus !== "Paid" &&
              !document?.clientApproval &&
              !isLandlordCopy && (
                <button
                  type="button"
                  onClick={() => {
                    setOpenApprovalModal({
                      isOpen: true,
                      approvalType: "Client",
                    });
                  }}
                  className="btn btn-outline-primary px-4 mr-3 font-normal font-weight-bold py-2 rounded"
                  disabled={isSaving}
                >
                  Send to Client
                </button>
              )}

            {/* {(!!document?.clientApproval || !!document?.landlordApproval) &&
              document?.paymentDetails?.paymentStatus !== "Paid" && (
                <button
                  type="button"
                  className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                  disabled={isSaving}
                  onClick={() => setMarkAsPaidModalOpen(true)}
                >
                  Add Payment
                </button>
              )} */}
          </div>

          {!!actions?.length &&
            document?.internalApproval?.status === "Approved" && (
              <div className="mt-md-0 ml-auto col-auto">
                <ListHeaderDropdown text="Action" actions={actions} />
              </div>
            )}
        </>
      </div>
    </div>
  );

  const renderAddNewUserHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={() => setOpenNewUserModal(false)}>
            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
          </div>
          <div className="col-auto font-base font-weight-bold">
            Add New User
          </div>
        </div>
      </div>
    );
  };

  const NewUserModal = (propertyId: string, approvalType: string) => {
    return (
      <div
        className="detail-poupup position-fixed top-0 w-50 h-100 overflow-auto in"
        style={{ maxWidth: "600px", zIndex: 1055 }}
      >
        {renderAddNewUserHeader()}
        {approvalType === "Client" ? (
          <>
          {/* <AddNewUserModal
            onClose={() => setOpenNewUserModal(false)}
            onCreateUser={() => setIsReload(true)}
            approvalType={approvalType}
            propertyId={propertyId || ""}
            companyId={companyId}
            gridColumns={3}
            /> */}
             <AddUser
                onClose={() => setOpenNewUserModal(false)}
                customerCreated={()=>setIsReload(true)}
                companyId={companyId}
            />
            </>
        ) : (
          <AddNewLandLord
            onClose={() => setOpenNewUserModal(false)}
            onCreateUser={() => setIsReload(true)}
            propertyId={propertyId || ""}
            approvalType={approvalType}
            companyId={companyId}
            AddNewUser={AddNewUserModal}
          />
        )}
      </div>
    );
  };

  const renderRejectConfirm = () => {
    return showRejectReasonModal ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <form onSubmit={rejectReasonHandleSubmit(onReject)}>
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <p>Are you sure to Reject the Invoice?</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group font-weight-semibold mb-3 text-left">
                          <label htmlFor="" className="font-sm text-uppercase">
                            Reason<span className="text-danger">*</span>
                          </label>
                          <Controller
                            control={rejectReasonControl}
                            name="reason"
                            rules={{ required: true }}
                            render={({ onChange, value, name }) => (
                              <DropdownList
                                value={value}
                                data={reasons}
                                defaultValue={value}
                                textField={"reason"}
                                valueField={"reason"}
                                placeholder={"Select Reason"}
                                onChange={(val) => {
                                  onChange(val.reason);
                                }}
                              />
                            )}
                          />
                          {rejectReasonErrors?.reason && (
                            <ErrorMessage>Reason is required</ErrorMessage>
                          )}
                        </div>

                        <div className="form-group font-weight-semibold mb-3 text-left">
                          <label htmlFor="" className="font-sm text-uppercase">
                            Comments
                          </label>
                          <Controller
                            control={rejectReasonControl}
                            name="comment"
                            render={({ onChange, value, name }) => (
                              <input
                                type="text"
                                className="form-control rounded-sm font-weight-semibold"
                                placeholder="Enter comment"
                                name={name}
                                value={value}
                                onChange={onChange}
                                id="comment"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-auto mr-auto">
                        <button
                          className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-5 px-4 mr-3"
                          type="button"
                          onClick={() => {
                            setShowRejectReasonModal(false);
                          }}
                          disabled={isSaving}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-auto">
                        <button
                          type="submit"
                          className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
                          disabled={isSaving}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  return (
    <>
      <div
        className={`bg-gray-100 detail-poupup  position-fixed top-0 w-100 h-100  in time-sheet-popup`}
        style={{ zIndex: 1052 }}
      >
        {renderHeader()}
        {renderRejectConfirm()}
        {loading && !proposalDocument ? (
          <ContainerLoader height={200}></ContainerLoader>
        ) : (
          <div className="container-fluid px-0 h-100">
            <div className="">
              <ul
                className="d-flex list-unstyled tab-underline font-sm font-weight-semibold border-bottom text-nowrap overflow-auto"
                id="activity-tab"
                role="tablist"
              >
                {proposalDocument?.document && (
                  <li className="nav-item pr-4 pl-4" role="presentation">
                    <a
                      className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                        tabName === UploadTabNames.InvoiceForCustomer
                          ? "active"
                          : ""
                      }`}
                      onClick={(e) => {
                        setOpenApprovalModal({});
                        setElementActive(UploadTabNames.InvoiceForCustomer);
                      }}
                    >
                      <span className="py-1 d-inline-flex">
                        Invoice For Customer
                      </span>
                    </a>
                  </li>
                )}
                {proposalDocument?.seperateDocumentForLandlord && (
                  <li className="nav-item pr-4 pl-4" role="presentation">
                    <a
                      className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                        tabName === UploadTabNames.InvoiceForLandlord
                          ? "active"
                          : ""
                      }`}
                      onClick={(e) => {
                        setOpenApprovalModal({});
                        setElementActive(UploadTabNames.InvoiceForLandlord);
                      }}
                    >
                      <span className="py-1 d-inline-flex">
                        Invoice For Vendor/Owner
                      </span>
                    </a>
                  </li>
                )}
                <li className="nav-item pr-4 pl-4" role="presentation">
                  <a
                    className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                      tabName === UploadTabNames.Log ? "active" : ""
                    }`}
                    onClick={(e) => {
                      setElementActive(UploadTabNames.Log);
                      setOpenApprovalModal({});
                    }}
                  >
                    <span className="py-1 d-inline-flex">Log</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="h-100 mt-2 px-4 row">
              <div className="col-md-8 col-12">
                {(tabName === UploadTabNames.InvoiceForCustomer ||
                  tabName === UploadTabNames.InvoiceForLandlord) && (
                  <>
                    <DocumentView
                      key={tabName}
                      mainTab={tabName}
                      paymentHistoryLoading={paymentHistoryLoading}
                      paymentHistory={paymentHistory}
                      currentFile={proposalDocument}
                      reload={() => {
                        props.reload?.();
                        reload(proposalDocument?._id);
                        paymentHistoryReload(proposalDocument?._id, tabName);
                      }}
                      changeDocument={(id: string) => {
                        reload(id);
                      }}
                      title={"Invoice"}
                      isLandlordCopy={isLandlordCopy}
                      onAddTransaction={()=>{ 
                        setMarkAsPaidModalOpen(true)}}
                      setDateFilters={setDateFilters}
                      dateFilters={dateFilters}
                    ></DocumentView>
                  </>
                )}

                {tabName === UploadTabNames.Log && <></>}
              </div>

              <div className="col-md-4 col-12 ">
                {documentId && (
                  <LeadActivities
                    leadId={props.leadId!}
                    documentId={documentId!}
                    stageCode={proposalDocument?.stageCode}
                    genericProposalDocumentId={proposalDocument?._id}
                    documentCopyType={isLandlordCopy ? DocumentCopyType.LandlordCopy : DocumentCopyType.ClientCopy}
                    onUpdate={() => {
                      // loadAllLog({
                      //   page: 1,
                      //   leadId: leadState?.leadDetails?._id,
                      //   customerId: leadState?.leadDetails?.customer?._id,
                      //   includeAllCustomerLogs: true,
                      // });
                      // closeAccordion();
                    }}
                    // onReload={props.onReload}
                  ></LeadActivities>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="modal-backdrop fade show" style={{ zIndex: 1051 }}></div>
      {openApprovalModal.isOpen && (
        <SendClientApprovalForm
          onClose={() => setOpenApprovalModal({})}
          approvalType={openApprovalModal.approvalType}
          proposalId={proposalDocument?.proposedPropertyDetails[0]?.proposalId}
          documentSettingsId={proposalDocument?.documentSettingsId}
          onSuccess={() => {
            setOpenApprovalModal({});
            props.reload?.();
            reload(proposalDocument?._id);
          }}
          documentId={proposalDocument?._id}
          title={"Invoice"}
          documentCopyType={isLandlordCopy ? "Landlord Copy" : "Client Copy"}
          onAddUser={(compId) => {
            setCompanyId(compId);
            setOpenNewUserModal(true);
            setIsReload(false);
          }}
          proposedPropertyId={
            proposalDocument?.proposedPropertyDetails[0]?.propertyDetails
              ?.propertyId
          }
          isReloadUser={isReload}
          compId={proposalDocument?.companyDetails?._id || ""}
        ></SendClientApprovalForm>
      )}
      {renderMarkAsPaid()}
      {openNewUserModal &&
        NewUserModal(
          proposalDocument?.proposedPropertyDetails[0]?.propertyDetails
            ?.propertyId,
          openApprovalModal?.approvalType || ""
        )}
    </>
  );
};

export default UploadDocument;
